import { Routes, Route, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { AppDataProvider } from "./context/AppDataContext";
import TabLayout from "./components/TabLayout";
import ChallengeDetail from "./pages/ChallengeDetail";
import Join from "./pages/Join";
import Resolve from "./pages/Resolve";

// Track if we've already handled the deep link (persists across re-renders)
let deepLinkHandled = false;

function AppRoutes() {
  const navigate = useNavigate();
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    const webApp = window.Telegram?.WebApp;
    if (webApp) {
      // Set theme colors to match our app
      webApp.setHeaderColor("#1a1a2e");
      webApp.setBackgroundColor("#1a1a2e");

      // Expand to full height
      webApp.expand();

      // Disable vertical swipes for smoother scrolling in our app
      if (webApp.disableVerticalSwipes) {
        webApp.disableVerticalSwipes();
      }

      // Handle startapp parameter (from deep links like t.me/bot?startapp=join_123)
      // Only process once per app session to prevent re-navigation loops
      const startParam = webApp.initDataUnsafe?.start_param;
      if (startParam && !deepLinkHandled) {
        deepLinkHandled = true;
        // Parse the start parameter
        if (startParam.startsWith("join_")) {
          const challengeId = startParam.replace("join_", "");
          navigate(`/join/${challengeId}`, { replace: true });
        } else if (startParam.startsWith("challenge_")) {
          const challengeId = startParam.replace("challenge_", "");
          navigate(`/challenge/${challengeId}`, { replace: true });
        }
      }

      // Signal that the app is ready
      webApp.ready();
    }
    setIsReady(true);
  }, [navigate]);

  if (!isReady) {
    return <div className="loading">Loading...</div>;
  }

  return (
    <div className="app">
      <Routes>
        {/* Main tabs layout */}
        <Route path="/" element={<TabLayout />} />

        {/* Dynamic pages - these work as overlays on top of tabs */}
        <Route path="/challenge/:challengeId" element={<ChallengeDetail />} />
        <Route path="/join/:challengeId" element={<Join />} />
        <Route path="/resolve/:challengeId" element={<Resolve />} />

        {/* Catch-all redirects to tabs */}
        <Route path="*" element={<TabLayout />} />
      </Routes>
    </div>
  );
}

function App() {
  return (
    <AppDataProvider>
      <AppRoutes />
    </AppDataProvider>
  );
}

export default App;
